import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { ReactNode } from 'react';
import type { ClientApi } from '@openclassrooms/sdk-web';
import Button from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';
interface Props {
  children: ReactNode;
  environment: number;
  userId: number;
  projectId: number;
  translations: {
    forbiddenError: string;
    genericError: string;
  };
  ocClient: ClientApi;
}
interface ApiError extends Error {
  statusCode?: number;
}
export default function RootMeButton(t0) {
  const $ = _c(20);
  const {
    children,
    environment,
    userId,
    projectId,
    translations,
    ocClient
  } = t0;
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [ltiAuthInfos, setLtiAuthInfos] = useState();
  let t1;
  if ($[0] !== environment || $[1] !== ocClient || $[2] !== projectId || $[3] !== translations || $[4] !== userId) {
    t1 = async () => {
      setIsRedirecting(true);
      ;
      try {
        const {
          body
        } = await ocClient.helpers.user.users.id(userId).projects.id(projectId).securityAudit.id(environment).generateLtiSignature.get();
        setLtiAuthInfos(body);
      } catch (t2) {
        const error = t2;
        const {
          statusCode
        } = error as ApiError;
        if (statusCode === 403) {
          setErrorMessage(translations.forbiddenError);
        } else {
          setErrorMessage(translations.genericError);
        }
        setIsRedirecting(false);
      }
    };
    $[0] = environment;
    $[1] = ocClient;
    $[2] = projectId;
    $[3] = translations;
    $[4] = userId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleClickToRedirect = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = form => {
      if (!form) {
        return;
      }
      form.submit();
      setIsRedirecting(false);
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleFormReady = t2;
  let t3;
  if ($[7] !== children || $[8] !== handleClickToRedirect || $[9] !== isRedirecting) {
    t3 = <Button isLoading={isRedirecting} variant="primary" onClick={handleClickToRedirect}>{children}</Button>;
    $[7] = children;
    $[8] = handleClickToRedirect;
    $[9] = isRedirecting;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== ltiAuthInfos || $[12] !== projectId) {
    t4 = ltiAuthInfos && <form data-testid={`rootme-form-${projectId}`} action="https://www.root-me.org/?action=api_lti" method="post" target="_blank" ref={handleFormReady}>{Object.entries(ltiAuthInfos).map(_temp)}</form>;
    $[11] = ltiAuthInfos;
    $[12] = projectId;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== errorMessage) {
    t5 = errorMessage && <Typography sx={{
      display: "block",
      marginTop: 2
    }} variant="body">{errorMessage}</Typography>;
    $[14] = errorMessage;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp(t0) {
  const [key, value] = t0;
  return <input key={key} type="hidden" name={key} value={value} />;
}